import _extends from '@babel/runtime/helpers/esm/extends';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useState, useEffect, useCallback } from 'react';
import { describe } from 'react-desc';
import LockUnlocked from '@elliemae/ds-icons/LockUnlocked';
import LockLocked from '@elliemae/ds-icons/LockLocked';
import VisibleView from '@elliemae/ds-icons/VisibleView';
import InvisibleHide from '@elliemae/ds-icons/InvisibleHide';
import DSButton from '@elliemae/ds-button';
import DSInputGroup from '../InputGroup/DSInputGroup.js';
import DSInputMask from '../InputMask/DSInputMask.js';
import { inputProtectedProps } from './props.js';
import { defaultProps } from './defaultProps.js';
import { LEFT_ADDON_OPTIONS, RIGHT_ADDON_OPTIONS } from './options.js';
export { LEFT_ADDON_OPTIONS, RIGHT_ADDON_OPTIONS } from './options.js';
import '../InputGroup/AddonWrapper.js';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import '@babel/runtime/helpers/esm/defineProperty';
import '@elliemae/ds-classnames';
import '../InputGroup/props.js';
import '../InputGroup/defaultProps.js';
import '@babel/runtime/helpers/esm/typeof';
import '../InputMask/MaskTypes.js';
import '../InputMask/MaskPipes.js';
import '../InputMask/addons/AutoCorrectedDatePipe.js';
import '../InputMask/DSInputMaskDeprecated.js';
import 'lodash';
import 'prop-types';
import 'text-mask-core';
import '../InputMask/utils/setCaretPosition.js';
import '../TextBox/DSTextBox.js';
import '../Input/DSInput.js';
import '../Input/InputImpl.js';
import '@elliemae/ds-icons/CloseCircle';
import '@elliemae/ds-tooltip';
import '../Input/InputAddonWrapper.js';
import '@babel/runtime/helpers/esm/toConsumableArray';
import '../Input/showEllipsis.js';
import '../InputMask/props.js';
import '../InputMask/defaultProps.js';
import '../InputMask/mask_types/index.js';
import '../InputMask/mask_types/DateInputMask.js';
import '../InputMask/mask_types/DateTimeInputMask.js';
import '../InputMask/mask_types/DictionaryInputMask.js';
import '../InputMask/mask_types/NumberInputMask.js';
import '../InputMask/mask_types/PhoneInputMask.js';
import '../InputMask/mask_types/PhoneInternationalInputMask.js';
import '../InputMask/mask_types/SsnInputMask.js';
import '../InputMask/mask_types/UsZipCodeInputMask.js';
import '../InputMask/mask_types/ZipCodeSearchInputMask.js';

var ADDON_ICON_OPTIONS = {
  LockUnlocked: /*#__PURE__*/React.createElement(LockUnlocked, null),
  LockLocked: /*#__PURE__*/React.createElement(LockLocked, null),
  VisibleView: /*#__PURE__*/React.createElement(VisibleView, null),
  InvisibleHide: /*#__PURE__*/React.createElement(InvisibleHide, null)
};

var DSInputProtected = function DSInputProtected(_ref) {
  var leftAddon = _ref.leftAddon,
      rightAddon = _ref.rightAddon,
      onChange = _ref.onChange,
      value = _ref.value,
      readOnly = _ref.readOnly,
      mask = _ref.mask,
      type = _ref.type,
      _ref$placeholderChar = _ref.placeholderChar,
      placeholderChar = _ref$placeholderChar === void 0 ? undefined : _ref$placeholderChar,
      rest = _objectWithoutProperties(_ref, ["leftAddon", "rightAddon", "onChange", "value", "readOnly", "mask", "type", "placeholderChar"]);

  var left = leftAddon && ADDON_ICON_OPTIONS[leftAddon];
  var right = rightAddon && ADDON_ICON_OPTIONS[rightAddon];

  var _useState = useState(leftAddon === LEFT_ADDON_OPTIONS.LockLocked),
      _useState2 = _slicedToArray(_useState, 2),
      inputLocked = _useState2[0],
      setLocked = _useState2[1];

  var _useState3 = useState(rightAddon === RIGHT_ADDON_OPTIONS.InvisibleHide),
      _useState4 = _slicedToArray(_useState3, 2),
      inputHidden = _useState4[0],
      setHidden = _useState4[1];

  useEffect(function () {
    setLocked(leftAddon === LEFT_ADDON_OPTIONS.LockLocked);
    setHidden(rightAddon === RIGHT_ADDON_OPTIONS.InvisibleHide);
  }, [leftAddon, rightAddon]);
  var handleLeft = useCallback(function () {
    setLocked(!inputLocked);
  }, [leftAddon, inputLocked]);
  var handleRight = useCallback(function () {
    setHidden(!inputHidden);
  }, [rightAddon, inputHidden]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DSInputGroup, {
    leftAddon: left ? /*#__PURE__*/React.createElement(DSButton, {
      "aria-label": "".concat(inputLocked ? 'Allow' : 'Disallow', " Edition"),
      buttonType: "secondary",
      icon: ADDON_ICON_OPTIONS[inputLocked ? LEFT_ADDON_OPTIONS.LockUnlocked : LEFT_ADDON_OPTIONS.LockLocked],
      onClick: handleLeft
    }) : undefined,
    readOnly: left ? inputLocked : readOnly,
    rightAddon: right ? /*#__PURE__*/React.createElement(DSButton, {
      "aria-label": "".concat(inputHidden ? 'Show' : 'Hide', " Characters"),
      buttonType: "secondary",
      icon: ADDON_ICON_OPTIONS[inputHidden ? RIGHT_ADDON_OPTIONS.VisibleView : RIGHT_ADDON_OPTIONS.InvisibleHide],
      onClick: handleRight,
      containerProps: {
        'data-testid': 'inputprotected-show-hide-button'
      }
    }) : undefined
  }, /*#__PURE__*/React.createElement(DSInputMask, _extends({}, rest, {
    mask: mask,
    placeholderChar: placeholderChar,
    onChange: onChange,
    readOnly: left ? inputLocked : readOnly,
    type: right && inputHidden ? 'password' : type,
    value: value
  }))));
};

DSInputProtected.propTypes = inputProtectedProps;
DSInputProtected.defaultProps = defaultProps;
var InputProtectedWithSchema = describe(DSInputProtected);
InputProtectedWithSchema.propTypes = inputProtectedProps;

export default DSInputProtected;
export { InputProtectedWithSchema };
//# sourceMappingURL=DSInputProtected.js.map
